export enum TypeEnum {
  "Home_Service" = 1,
  "Professional_Service" = 2,
  "International_Service" = 3,
}
